import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NoBaskets from './NoBaskets'
import BasketsList from './BasketsList'
import {Spin} from 'antd'

class BasketsListContainer extends Component {
    _renderTableContent = () => {
        const {baskets, reload, reloadFlag} = this.props

        if (baskets.length === 0) {
            return <NoBaskets/>
        }

        return <BasketsList baskets={baskets} reload={reload} reloadFlag={reloadFlag}/>
    }

    render() {
        const tableContent = this._renderTableContent()
        const {loading} = this.props

        return (
            <div className='BasketsListContainer'>
                <Spin spinning={loading} tip='Loading...'>
                    <div className='BasketsListWrap'>
                        {tableContent}
                    </div>
                </Spin>
            </div>
        )
    }
}

BasketsListContainer.propTypes = {
    baskets: PropTypes.array.isRequired,
}

export default BasketsListContainer
